import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(() => ({
  formSection: {
    paddingBottom: '10px',
  },
}));

const PlateStateFilter = (props) => {
  const classes = useStyles();

  const handleFilterPlateStateChange = (event, value) => {
    props.setSelectedPlateState(value);
  };

  const getLabel = (option) => option.Code;
  const getOptionLabel = (option) =>
    option.Code + (option.Description ? ` - ${option.Description}` : '');

  return (
    <FormControl fullWidth variant="outlined" className={classes.formSection}>
      <Autocomplete
        labelid="plate-state"
        value={props.selectedPlateState}
        onChange={handleFilterPlateStateChange}
        options={props.states}
        getOptionLabel={getLabel}
        getOptionSelected={(option, value) => option.code === value.code}
        renderOption={getOptionLabel}
        renderInput={(params) => (
          <TextField {...params} fullWidth label="Plate State" variant="outlined" size="small" />
        )}
      />
    </FormControl>
  );
};

export default PlateStateFilter;
